import { cn } from "@src/lib/utils/cn";

interface Props {
  className?: string;
}

const AiChatBackground: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        "absolute inset-x-0 top-0 -z-10 flex size-full items-end justify-center opacity-20 blur-[18px]",
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="226"
        height="156"
        viewBox="0 0 226 156"
        className="relative top-[32px] rotate-[112.83deg]"
      >
        <ellipse
          cx="75.6208"
          cy="113.751"
          rx="75.6208"
          ry="113.751"
          transform="matrix(-0.400928 0.916109 -0.952366 -0.304958 251.664 43.3782)"
          fill="url(#paint0_radial_445_18088)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_445_18088"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(11.8783 51.7286) rotate(52.7032) scale(221.088 215.12)"
          >
            <stop offset="0.545865" stopColor="#ADBDFF" />
            <stop offset="0.964958" stopColor="#FFE276" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="247"
        height="179"
        viewBox="0 0 247 179"
        className="ml-[-64px] rotate-[-57.433deg]"
      >
        <ellipse
          cx="81.8299"
          cy="127.693"
          rx="81.8299"
          ry="127.693"
          transform="matrix(0.569656 -0.821884 0.891869 0.452294 -36.9902 99.0015)"
          fill="url(#paint0_radial_445_18089)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_445_18089"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.8536 58.0687) rotate(53.7118) scale(244.94 235.868)"
          >
            <stop offset="0.296902" stopColor="#ADBDFF" />
            <stop offset="0.710698" stopColor="#FFE276" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};

export default AiChatBackground;
